module.exports = __webpack_public_path__ + "57d344633694d139bae786771850d235.pdf";